require.register("thesaurus/app", function(exports, require, module){
  $0
  
});

